import React, { useMemo, useState } from 'react';
import { makeStyles, TextInput } from 'design-system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Fuse from 'fuse.js';
import { flattenWithPath } from '../utils';
import { useProjectInstructionContext } from '../projectInstructionContext';

const SearchBar = () => {
  const classes = useStyles();
  const { isMobileView, setSelectedPath, components, setSearchResult } =
    useProjectInstructionContext();
  const [inputValue, setInputValue] = useState<string>('');

  const flattenComp = useMemo(() => flattenWithPath(components, []), [components]);
  const fuse = useMemo(() => {
    const options = {
      includeScore: true,
      includeMatches: true,
      useExtendedSearch: true,
      // Search in `title` and in `description` array
      keys: ['title', 'description'],
    };
    return new Fuse(flattenComp, options);
  }, [flattenComp]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // When search bar is empty, exit search results.
    if (!inputValue) {
      setSearchResult(null);
    }
    // Execute search.
    if (inputValue && e.key === 'Enter') {
      const searchResults = fuse.search(`'"${inputValue}"`);
      // @ts-ignore
      setSearchResult(searchResults.reverse());
      setSelectedPath([]);
    }
  };

  return (
    <div className={isMobileView ? classes.sidePanelContainer : classes.searchBar}>
      <TextInput
        startAdornment={
          <FontAwesomeIcon
            icon="search"
            color={isMobileView ? 'var(--color-RemoGray50)' : 'black'}
          />
        }
        placeholder={isMobileView ? 'Search...' : 'Search Instructions'}
        fullWidth
        classes={{ root: isMobileView ? classes.sidePanelRootStyle : classes.root }}
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  searchBar: {
    height: 30,
    maxWidth: 250,
    marginLeft: 'auto',
    marginBottom: 10,
  },

  sidePanelContainer: {
    width: '100%',
    marginBottom: 0,
  },

  sidePanelRootStyle: {
    margin: '10px 12px',
    maxWidth: '90%',
  },

  root: {
    background: theme.colors.gray05,
    '& fieldset': {
      border: 'none',
    },
  },
}));

export default SearchBar;
